import React, {useEffect} from 'react'
import AppBar from 'components/complex/appbar/AppBar';
import Navigation from "components/complex/navigation/Navigation";
import ContractorRouter from "./ContractorRouter";
import UploadService from "../../services/UploadService";
import CustomerIOAnalytics from "./customerio/CustomerIOAnalytics";


function ContractorRoot() {

    useEffect(()=>{
        UploadService.getValidExtensions();
        return ()=> UploadService.clearValidExtensionsResource();
    },[]);

    return (
        <>
            <Navigation />
            <AppBar id="toolBar"/>
            <ContractorRouter/>
            <CustomerIOAnalytics/>
        </>
    )
}

export default ContractorRoot;
